// Added by Sejune Oh on 2019-03-29
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Define
import { GetQueryParams, GetQueryReturn } from '../../helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Store
import Rootstore from '..'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface StoreBaseProps<T> {
    get?: () => Promise<T>
    getAll?: () => Promise<T>
    update?: () => Promise<T>
    remove?: () => Promise<T>
    getAssigned?: (prop: string, value: string) => Promise<T>
    checkDuplicated?: (prop: string, value: string) => Promise<T>
}

export interface StoreBaseConstructorProps {
    storeName: string
    _root: Rootstore
}

interface RequestParamProps {
    url: string
    data?: any
}

interface ReqHandlerParamProps {
    requestFunc: any
    param: RequestParamProps
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class StoreBase<T> {
    _storeName: string
    _root: Rootstore

    constructor({ storeName, _root }: StoreBaseConstructorProps) {
        this._storeName = storeName
        this._root = _root
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    _getRequest({ url }: RequestParamProps) {
        return axios.get<T | GetQueryReturn<T>>(url)
    }

    _postRequest({ url, data }: RequestParamProps) {
        return axios.post<T>(url, data)
    }

    _putRequest({ url, data }: RequestParamProps) {
        return axios.put<T | Array<T>>(url, data)
    }

    _deleteRequest({ url }: RequestParamProps) {
        return axios.delete(url)
    }

    async _reqHandler({ requestFunc, param }: ReqHandlerParamProps) {
        return await requestFunc(param)
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    get(param: any) {
        return this._reqHandler({
            requestFunc: this._getRequest,
            param,
        })
    }

    post(param: any) {
        return this._reqHandler({
            requestFunc: this._postRequest,
            param,
        })
    }

    put(param: any) {
        return this._reqHandler({
            requestFunc: this._putRequest,
            param,
        })
    }

    delete(param: any) {
        return this._reqHandler({
            requestFunc: this._deleteRequest,
            param,
        })
    }

    getQueryPath = ({ pageIndex = 0, pageSize, order = 'desc', orderBy, filter }: GetQueryParams): string => {
        const queries = []
        queries.push(`page_index=${pageIndex + 1}`)

        if (pageSize) {
            queries.push(`page_size=${pageSize}`)
        }

        if (orderBy) {
            queries.push(`order_by=${orderBy}:${order}`)
        }

        if (filter) {
            queries.push(`filter=${filter}`)
        }

        return queries.join('&')
    }
}
